import { render, staticRenderFns } from "./RankingAgents.vue?vue&type=template&id=203396af&scoped=true&"
import script from "./RankingAgents.vue?vue&type=script&lang=js&"
export * from "./RankingAgents.vue?vue&type=script&lang=js&"
import style0 from "./RankingAgents.vue?vue&type=style&index=0&id=203396af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203396af",
  null
  
)

export default component.exports